<template>
    <h1>Page industries</h1>
</template>

<script>
    export default {
        name: "page-industries"
    };
</script>

<style scoped lang="scss" src="./style.scss"></style>
